import { IMe } from '../types';

export function isUserInSupportMode(me: IMe) {
  return me.id === '0';
}
